module.exports = __webpack_public_path__ + "static/winter-7bb03d6350c39930df05939d38c06823.jpg";